<template>
  <view>
    <es-face tickets12306="{{tickets12306}}"></es-face>
  </view>
</template>


<script>
  import { createPage } from '@didi/es-mpx-creator'
  createPage({
    data: {
      inputdata: '',
      isShowDialog: false,
      tickets12306: false
    },
    methods: {
      // bindModel(event) {
      //   this.inputdata = event.detail.value
      // },
      // showTravelQuota() {
      //   this.isShowDialog = true
      // },
      // close() {
      //   this.isShowDialog = false
      // }
    },
    created() {
      const { from } = this.$mpxRoute?.query
      this.tickets12306 = from === 'tickets12306' ? true : false
    }
  })
</script>

<style lang='stylus' scoped>
  .es-witn-verification
    background #ffffff
</style>

<script name='json'>
  module.exports = {
    component: true,
    // navigationBarTitleText: '人证核验',
    usingComponents: {
      'es-face': './components/face/index'
    }
  }
</script>